import Unknown from '@clearkit/icons/glyphs/Unknown';
import { CKTooltip } from '@clearkit/react';
import classnames from 'classnames';

const FieldMappingHeaders = (hasEnrichmentBetaUIFlag) => {
  const headerClasses = classnames('mb-3 text-gray-600', {
    'mt-6 mapping-row-header': !hasEnrichmentBetaUIFlag,
    'selective-enrichment-mapping-header': hasEnrichmentBetaUIFlag,
  });

  return (
    <div className={headerClasses}>
      <p className="text-base font-medium">Source</p>
      <p className="pl-4 text-base font-medium">Target</p>
      <div className="flex items-center justify-start pl-4">
        <p className="pl-4 pr-2 text-base font-medium">
          {hasEnrichmentBetaUIFlag
            ? 'Field overwrite preference'
            : 'Hard Overwrite'}
        </p>
        <CKTooltip
          tooltip={
            <p className="mr-2 text-base font-normal">
              By default, Clearbit will never overwrite your manually entered
              data. Enabling Hard Overwrite will ensure that we force overwrite
              the field with new data regardless of its previous value.
            </p>
          }
          arrowPlacement="bottom"
          options={{ placement: 'top-start' }}
          animated={false}>
          <div className="flex outline-none">
            <Unknown width="16" height="16" />
          </div>
        </CKTooltip>
      </div>
    </div>
  );
};

export default FieldMappingHeaders;
